import { render } from "./BaseLabel.vue?vue&type=template&id=4b4995fd&scoped=true"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"

import "./BaseLabel.vue?vue&type=style&index=0&id=4b4995fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4995fd"]])

export default __exports__